import { render, staticRenderFns } from "./ReportCenter.vue?vue&type=template&id=55e8b870&scoped=true&"
import script from "./ReportCenter.vue?vue&type=script&lang=js&"
export * from "./ReportCenter.vue?vue&type=script&lang=js&"
import style0 from "./ReportCenter.vue?vue&type=style&index=0&id=55e8b870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e8b870",
  null
  
)

export default component.exports